import { call, put, takeLatest } from 'redux-saga/effects';
import { httpRequestsOnLoadActions } from '../../http_requests_on_load';
import { httpRequestsOnSuccessActions } from '../../http_requests_on_success';
import { httpRequestsOnErrorsActions } from '../../http_requests_on_errors';
import {
    SAVE_ASSESSMENT,
    DELETE_ASSESSMENT,
    EDIT_ASSESSMENT,
    GET_ASSESSMENTS,
    GET_ASSESSMENTS_SUCCESS,
    CREATE_ASSESSMENT,
    GET_ASSESSMENT_BY_ID,
    GET_ASSESSMENT_BY_ID_SUCCESS,
} from './assessment.types';
import { authService } from './assessment.service';

/** Assessments */

function* getAssessments({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    if (payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(type));
    }
    try {
        const res = yield call(authService.getAssessmentsService, payload?.clientId, payload?.params);
        yield put({
            type: GET_ASSESSMENTS_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* getAssessmentById({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    if (payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(type));
    }
    try {
        const res = yield call(authService.getAssessmentByIdService, payload?.assessmentId);
        yield put({
            type: GET_ASSESSMENT_BY_ID_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* createAssessment({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        const res = yield call(authService.createAssessmentService, payload?.clientId);
        yield put(httpRequestsOnSuccessActions.appendSuccess(type, res?.data));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
    }
}

function* saveAssessment({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield put(httpRequestsOnLoadActions.appendLoading(GET_ASSESSMENTS));
        yield call(authService.saveAssessmentsService, payload?.clientId);
        const res = yield call(authService.getAssessmentsService, payload?.clientId, payload?.reqParams);
        yield put({
            type: GET_ASSESSMENTS_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(GET_ASSESSMENTS));
        yield put(httpRequestsOnSuccessActions.appendSuccess(type, res?.data));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
    }
}

function* editAssessment({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(authService.editAssessmentService, payload?.id, payload?.body);
        // const res = yield call(authService.getAssessmentsService, payload?.params);
        // yield put({
        //     type: GET_ASSESSMENTS_SUCCESS,
        //     payload: res.data,
        // });
        yield put(httpRequestsOnErrorsActions.removeError(type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* deleteAssessment({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(authService.deleteAssessmentService, payload?.id);
        // const res = yield call(authService.getAssessmentsService, payload?.params);
        // yield put({
        //     type: GET_ASSESSMENTS_SUCCESS,
        //     payload: res.data,
        // });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

/** End */

export const watchAssessment = function* watchAssessmentAuth() {
    /** Assessments  */
    yield takeLatest(GET_ASSESSMENTS, getAssessments);
    yield takeLatest(GET_ASSESSMENT_BY_ID, getAssessmentById);
    yield takeLatest(CREATE_ASSESSMENT, createAssessment);
    yield takeLatest(SAVE_ASSESSMENT, saveAssessment);
    yield takeLatest(EDIT_ASSESSMENT, editAssessment);
    yield takeLatest(DELETE_ASSESSMENT, deleteAssessment);
    /** End */
};
